import { z } from 'zod/v3';
import { PlanSchema } from '../generated/enums';

const NumericLimitSchema = z.union([z.literal(-1), z.number().nonnegative()]);

export const PlanUsageMetricSchema = z.object({
  used: z.number().nonnegative(),
  limit: NumericLimitSchema,
  percentage: z.number(),
}).strict();

export const SubscriptionFeatureUsageSchema = z.object({
  key: z.string(),
  count: z.number().nonnegative(),
}).strict();

export const SubscriptionUsageDTOSchema = z.object({
  plan: PlanSchema,
  usage: z.object({
    topics: PlanUsageMetricSchema,
    workspaces: PlanUsageMetricSchema,
    members: PlanUsageMetricSchema,
    storage: PlanUsageMetricSchema,
    aiCredits: PlanUsageMetricSchema,
    privateReaders: PlanUsageMetricSchema,
  }).strict(),
  features: z.array(SubscriptionFeatureUsageSchema),
}).strict();

export const PlanLimitsDTOSchema = z.object({
  plan: PlanSchema,
  limits: z.object({
    topics: NumericLimitSchema.optional(),
    workspaces: NumericLimitSchema.optional(),
    members: NumericLimitSchema.optional(),
    storage: NumericLimitSchema.optional(),
    aiCredits: NumericLimitSchema.optional(),
    privateReaders: NumericLimitSchema.optional(),
  }).strict(),
}).strict();

export type PlanUsageMetricDTO = z.infer<typeof PlanUsageMetricSchema>;
export type SubscriptionUsageDTO = z.infer<typeof SubscriptionUsageDTOSchema>;
export type PlanLimitsDTO = z.infer<typeof PlanLimitsDTOSchema>;
